export default __webpack_public_path__ + "static/media/Copy_btn.fd175ad1.svg";